<template>
<div class="chapter">
<div class="inner_page">
<div class="full-width-image" id="preview_cover"><span><img alt="image" class="svg1" src="images/Brooks_the_Pied_Piper_02.jpg"/></span>
<p class="caption"><span>“<i>There, you see?” he said. “Two cents</i>—<i>that’s his price</i>.”</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?380d8abd